module.exports = __webpack_public_path__ + "19834bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/search/noResult.png
// module id = 1268
// module chunks = 8